{
    "actions": {
        "page": {
            "multiple_block": {
                "title": "Multiple blocking",
                "select": "Blocking by selection",
                "upload": "Blocking by CSV file"
            },
            "multiple_rewarehouse": "Restock",
            "multiple_activation": "Activate"
        },
        "row": {
            "allow": "Allow",
            "block": "Block now",
            "scheduled_block": "Block later",
            "temporarily_allow": "Temporary allow",
            "rewarehouse": "Restocking",
            "refresh": "Refresh status",
            "update_labels": "Update",
            "posTerminal_info_pos_status": "Info Statut TPE"
        }
    },
    "authorization_code": {
        "EMPTY": "Not specified",
        "00": "Approved",
        "02": "Refer to card issuer",
        "03": "Invalid acceptor",
        "04": "Pick-up",
        "05": "Do not honour",
        "07": "Pick up card, special condition",
        "08": "Honour with identification",
        "10": "Approved for partial amount",
        "12": "Invalid transaction",
        "13": "Invalid amount",
        "14": "Invalid PAN",
        "15": "Unknown issuer",
        "17": "Customer cancellation",
        "19": "Retry later",
        "20": "Invalid response (error in server domain)",
        "21": "Transaction not executed",
        "24": "Unsupported file update",
        "25": "Unable to locate record in file",
        "26": "Duplicate registration, the previous record has been replaced",
        "27": "File update edit error",
        "28": "Denied access to file",
        "29": "Unable to update",
        "30": "Format error",
        "31": "Unknown acquiring institution identification code",
        "32": "Completed partially",
        "33": "Expired card",
        "34": "Suspected fraud",
        "38": "Number of PIN code input exceeded",
        "41": "Lost card",
        "43": "Stolen card",
        "46": "Business specific error",
        "51": "Insufficient funds or credit limit exceeded",
        "54": "Expired card",
        "55": "Incorrect PIN code",
        "56": "No card record",
        "57": "Transaction not permitted for this cardholder",
        "58": "Transaction not permitted to terminal",
        "59": "Suspected fraud",
        "60": "Card acceptor must contact the acquirer",
        "61": "Exceeds withdrawal amount limit",
        "62": "Restricted card",
        "63": "Security rules violation",
        "68": "Response received too late",
        "75": "Number of attempts for entering the PIN code exceeded",
        "76": "The cardholder is already blocked, previous record saved",
        "77": "Closed account",
        "78": "Blocked, first used transaction from new cardholder, and car not properly unblocked",
        "90": "Momentary system cut-off",
        "91": "Issuer or switch is inoperative",
        "93": "Transaction cannot be completed-Violation of law",
        "94": "Duplicate transmission",
        "96": "System malfunction",
        "97": "Global monitoring timeout",
        "98": "Server unavailable - network re-routing requested",
        "99": "Initiator domain incident",
        "NR": "No received response",
        "6P": "Verification data failed",
        "A0": "Fallback in contact mode",
        "A1": "Soft decline",
        "A2": "PIN request in single TAP mode",
        "A3": "New TAP with required authentification",
        "A4": "Misused TRA exemption",
        "R0": "Stop payment order",
        "R1": "Revocation of all the recurring payments for the card at the merchant",
        "R3": "Revocation of all recurring payments for the card",
        "TNA": "Empty"
    },
    "authorization_code_options": {
        "EMPTY": "Empty",
        "00": "00 - Approved",
        "02": "02 - Refer to card issuer",
        "03": "03 - Invalid acceptor",
        "04": "04 - Pick-up",
        "05": "05 - Do not honour",
        "07": "07 - Pick up card, special condition",
        "08": "08 - Honour with identification",
        "10": "10 - Approved for partial amount",
        "12": "12 - Invalid transaction",
        "13": "13 - Invalid amount",
        "14": "14 - Invalid PAN",
        "15": "15 - Unknown issuer",
        "17": "17 - Customer cancellation",
        "19": "19 - Retry later",
        "20": "20 - Invalid response (error in server domain)",
        "21": "21 - Transaction not executed",
        "24": "24 - Unsupported file update",
        "25": "25 - Unable to locate record in file",
        "26": "26 - Duplicate registration, the previous record has been replaced",
        "27": "27 - File update edit error",
        "28": "28 - Denied access to file",
        "29": "29 - Unable to update",
        "30": "30 - Format error",
        "31": "31 - Unknown acquiring institution identification code",
        "32": "32 - Completed partially",
        "33": "33 - Expired card",
        "34": "34 - Suspected fraud",
        "38": "38 - Number of PIN code input exceeded",
        "41": "41 - Lost card",
        "43": "43 - Stolen card",
        "46": "46 - Business specific error",
        "51": "51 - Insufficient funds or credit limit exceeded",
        "54": "54 - Expired card",
        "55": "55 - Incorrect PIN code",
        "56": "56 - No card record",
        "57": "57 - Transaction not permitted for this cardholder",
        "58": "58 - Transaction not permitted to terminal",
        "59": "59 - Suspected fraud",
        "60": "60 - Card acceptor must contact the acquirer",
        "61": "61 - Exceeds withdrawal amount limit",
        "62": "62 - Restricted card",
        "63": "63 - Security rules violation",
        "68": "68 - Response received too late",
        "75": "75 - Number of attempts for entering the PIN code exceeded",
        "76": "76 - The cardholder is already blocked, previous record saved",
        "77": "77 - Closed account",
        "78": "78 - Blocked, first used transaction from new cardholder, and car not properly unblocked",
        "90": "90 - Momentary system cut-off",
        "91": "91 - Issuer or switch is inoperative",
        "93": "93 - Transaction cannot be completed-Violation of law",
        "94": "94 - Duplicate transmission",
        "96": "96 - System malfunction",
        "97": "97 - Global monitoring timeout",
        "98": "98 - Server unavailable - network re-routing requested",
        "99": "99 - Initiator domain incident",
        "NR": "NR - No received response",
        "6P": "6P - Verification data failed",
        "A0": "A0 - Fallback in contact mode",
        "A1": "A1 - Soft decline",
        "A2": "A2 - PIN request in single TAP mode",
        "A3": "A3 - New TAP with required authentification",
        "A4": "A4 - Misused TRA exemption",
        "R0": "R0 - Stop payment order",
        "R1": "R1 - Revocation of all the recurring payments for the card at the merchant",
        "R3": "R3 - Revocation of all recurring payments for the card"
    },
    "authorization_code_result": {
        "AUTHORIZED": "Authorized",
        "NOT_VERIFIED": "Validated",
        "REFUSED": "Refused",
        "PENDING": "Pending",
        "EXPIRED": "Expired",
        "CANCELLED": "Cancelled"
    },
    "cb_logo": {
        "unknown_card": "Unknown card"
    },
    "entry_port": {
        "origin": "(Redirected {{originEntryPort}})"
    },
    "event_type": {
        "AUTHORIZATION": "Authorization",
        "REMOTE_COLLECTION": "Remitted",
        "NOT_COMPLETED": "Not completed",
        "INTERRUPTED": "Interrupted",
        "IN_PROGRESS": "In progress"
    },
    "filter": {
        "placeholder": {
            "provider_legal_name": "Filter by direct provider",
            "serial_number": "Filter by serial #",
            "manufacturer": "Filter by manufacturer",
            "label": "Filter by POS label",
            "custom_label": "Filter by POS label 2",
            "event_logs": {
                "entry_port": "Filter by port",
                "x121_address": "Filter by X25 Unit",
                "application_id": "Filter by ITP",
                "acceptance_system_number": "Filter by rank",
                "bank_code": "Filter by bank code",
                "acceptance_agreement_number": "Filter by contract",
                "company_registration_number": "Filter by CRN"
            },
            "transactions": {
                "pan": "Filter by card number",
                "contract": "Filter by contract",
                "bank_code": "Filter by bank code",
                "rank": "Filter by rank",
                "authorization_number": "Filter by auth. #",
                "reconciliation_number": "Filter by reconcil. #",
                "pos_remittance_number": "Filter by file #",
                "file_number": "Filter by rent. file #",
                "legal_name": "Filter by legal name",
                "registration_number": "Filter by CRN"
            }
        }
    },
    "keys": {
        "provider_legal_name": "Direct provider",
        "serial_number": "Serial #",
        "manufacturer": "Manufact.",
        "label": "POS label",
        "custom_label": "POS label 2",
        "status": "Status POS",
        "rewarehouse_at": "Rewarehoused on",
        "network_interface_type": "Last connection type",
        "last_gprs_call": "Last GRPS co.",
        "created_at": "Added on",
        "updated_at": "Updated at",
        "last_connection_ip": "Last connection IP",
        "blocked_at": "Blocked on",
        "event_logs": {
            "network_information": {
                "entry_port": "Port"
            },
            "device_information": {
                "network_interface_type": "Type"
            },
            "destination_information": {
                "address": {
                    "x121_address": "X25 Unit"
                }
            },
            "financial_information": {
                "operations": "Operations",
                "acceptance_system_information": {
                    "application_id": "ITP",
                    "acceptance_system_number": "Rank",
                    "bank_code": "Bank code",
                    "acceptance_agreement_number": "Contract",
                    "company_registration_number": "CRN"
                }
            },
            "metrics_information": {
                "started_at": "Call date"
            },
            "version_cb": "BC"
        },
        "sim": {
            "status": "SIM status",
            "activated_on": "Activated on",
            "offer": "Plan"
        },
        "transactions": {
            "label": "POS label",
            "local_transaction_date_time": "Date",
            "pan": "Card number",
            "expiration_date": "Expir.",
            "amount": "Amount",
            "authorization_number": "Auth. #",
            "authorization_code": "Return code",
            "authorization_code_result": "Result",
            "type": "Type",
            "contract": "Contract",
            "reconciliation_number": "Reconcil. #",
            "pos_remittance_number": "File #",
            "card_type": "Issuer",
            "card_product": "Product",
            "rank": "Rank",
            "bank_code": "Bank code",
            "legal_name": "Legal name",
            "registration_number": "CRN",
            "file_number": "Rent. file #",
            "event_type": "Transactions"
        }
    },
    "modal": {
        "geolocation": {
            "title": "Calls geolocation",
            "informations": "This information is purely indicative",
            "error": {
                "api": "An error occurred while locating terminals",
                "map": "Map unavailable"
            },
            "not_found": "No location available for this terminal",
            "not_found_ip": "Geolocation unavailable for IP {{sourceAddressIp}}",
            "not_activated": {
                "title": "Calls geolocation",
                "text": "Information unavailable"
            }
        },
        "unblacklist": {
            "title": "Allow POS Terminal",
            "text": "Do you want to allow this POS Terminal?",
            "success": "POS Terminal successfully allowed!",
            "error": "An error occured while allowing POS Terminal",
            "no_connection_points": "Impossible to allow the POS Terminal: no connection point attached to the terminal"
        },
        "blacklist": {
            "title": "Block POS Terminal",
            "text": "Do you want to block this POS Terminal?",
            "success": "POS Terminal has been successfully blocked",
            "error": "An error occured while blocking POS Terminal",
            "no_connection_points": "Impossible to block the POS Terminal: no connection point attached to the terminal",
            "scheduled": {
                "text": "Scheduled POS Terminal blockage",
                "summary": "POS terminal will be blocked on {{date}} at {{time}}.",
                "success": "POS Terminal is now scheduled to be blocked on {{date}} at {{time}}.",
                "error": "An error has occurred while attempting to schedule a date to block POS Terminal."
            }
        },
        "allow_temporarily": {
            "title": "Temporarily allow POS Terminal",
            "text": "POS Terminal will be authorised for 24 hours, do you want to continue?",
            "success": "POS Terminal successfully temporarily allowed!",
            "error": "An error occured while temporarily allowing POS Terminal",
            "no_connection_points": "Impossible to temporarily allow the POS Terminal: no connection point attached to the terminal"
        },
        "rewarehouse": {
            "title": "Confirmation of restocking",
            "success": "POS Terminal has been successfully restocked",
            "error": "An error has occurred while restocking POS Terminal",
            "text_1": "POS Terminal will be returned to stock and will no longer be linked to the current merchant.",
            "text_2": "It will be automatically assigned to a new merchant the next time it is recollected, authorised or remotely set, and will appear again in the list of subscriptions.",
            "text_3": "Would you like to continue?"
        },
        "update_labels": {
            "title": "Update POS Terminal's labels",
            "label": "POS Terminal label",
            "custom_label": "POS Terminal label 2",
            "placeholder": "Maximum 100 characters",
            "success": "POS Terminal's labels have been successfully updated",
            "error": "An error has occured while updating POS Terminal's labels"
        },
        "info_status": {
            "title": "POS terminal status",
            "serial_number": "Serial #",
            "manufacturer": "Manufacturer",
            "portal": "POS terminal status on the portal (DB)",
            "gateway": "POS terminal status on the gateway (Redis)",
            "key_list_redis": "Redis key's list fetched",
            "fetching_time": "Redis status fetching time",
            "connexion_point": "Connexion point",
            "value": "Value",
            "status": "Status",
            "status_gateway": "Statut",
            "till": "till"
        },
        "multiple_activation": {
            "title": "Multiple POS terminal activation",
            "success": "Multiple POS terminal activation successful!",
            "error": "We encountered an error during multiple activation. Please try again.",
            "steps": {
                "select_pos_terminals": "Step {{step}} on {{maxStep}}: Select Pos terminals",
                "select_plan": "Step {{step}} on {{maxStep}}: Select a plan",
                "confirmation": "Step {{step}} on {{maxStep}}: Confirmation"
            },
            "confirmation": {
                "text": "You have selected {{number}} POS terminals for multiple activation",
                "question": "Would you like to continue?"
            }
        },
        "multiple_blocking": {
            "title": "Multiple POS terminal blocking",
            "success": "The multiple block has been successfully completed!",
            "error": "We have encountered an error with multiple blocking. Please try again.",
            "error_with_list1": "Multiple blocking was partially carried out because of errors in the list.",
            "error_with_list2": "Below is the list of POS terminals numbers that have not been blocked:",
            "by_selection": {
                "steps": {
                    "select_subscription": "Step {{step}} on {{maxStep}}: Select Pos terminals (maximum 50 Pos terminals)",
                    "select_blocking_mode": "Step {{step}} on {{maxStep}}: Select type of multiple blocking",
                    "confirmation": "Step {{step}} on {{maxStep}}: Confirmation"
                },
                "confirmation": {
                    "text_1": "You have selected {{number}} POS terminals for multiple blocking",
                    "text_2": "The multiple block will take effect on {{date}} at {{time}}.",
                    "question": "Would you like to continue?"
                }
            }
        },
        "multiple_blocking_import": {
            "explanations": {
                "header": "You can block POS terminals by CSV file. The file to import must contain the following 6 columns :",
                "organization": "Organisation: name of the organization that owns the terminals to block",
                "serial_number": "Série: serial number of the terminals to block. It can contain one or more values separated by commas (example \"CT0881958, CT1234565, TH04072458\")",
                "direct_profider": "Fournisseur direct: name of the direct provider of the terminal",
                "constructor": "Constructeur: name of the constructor of the terminal",
                "label": "Libellé TPE ou code client: POS label or client code to better identify the organization",
                "siret": "Siret: Siret number of the organization",
                "multiple_terminals": "It is possible to add multiple terminals for the same organization, for this, the \"serial number\" field must be filled for each terminal for the organization in question. A model with examples is downloadable to help you prepare your CSV file.",
                "warning": "Attention: only terminals with an enabled subscription status and pending, with a TPE authorized and temporary status are blockable."
            },
            "confirmation": "This operation will block {{numberOfTerminals}} terminals. Do you want to continue?",
            "success": "The terminals have been blocked successfully!",
            "error": {
                "invalid_file": "This file is not compatible (.csv only)",
                "header": "The multiple blocking of terminals has been partially carried out due to errors in the CSV. Below is the list of terminals that have not been blocked and their errors:",
                "footer": "You can correct these errors and try to block the terminals again later.",
                "BAD_FORMAT": "Format error in the file",
                "INTERNAL_SERVER_ERROR": "An unknown error occurred",
                "MORE_THAN_ORGANIZATION_FOR_SINGLE_LINE": "More than one organization is provided for this terminal",
                "MISSING_OR_EMPTY_VALUES": "This terminal has missing or empty values",
                "POS_TERMINAL_NOT_FOUND": "This terminal is not found",
                "DUPLICATE_TERMINALS": "This terminal is duplicated in the file",
                "ORGANIZATION_NOT_FOUND": "The organization for this terminal is not found",
                "DIRECT_PROVIDER_NOT_FOUND": "The direct provider for this terminal is not found",
                "MULTIPLE_DIRECT_PROVIDERS_FOUND_FROM_LEGAL_NAME": "Multiple direct providers are found for the direct provider name provided for this terminal",
                "MULTIPLE_ORGANIZATIONS_FOUND_FROM_LEGAL_NAME": "Multiple organizations are found for the organization name provided for this terminal",
                "POS_TERMINAL_SUBSCRIPTION_NOT_FOUND": "The subscription for this terminal is not found",
                "INCONSISTENT_VALUES": "The values related to this terminal are not consistent",
                "EXCEEDING_POS_TERMINAL_MAXIMUM_COUNT": "The number of terminals to block is exceeded",
                "POS_TERMINAL_ALREADY_BLOCKED": "This terminal is already blocked",
                "POS_TERMINAL_SUBSCRIPTION_IN_STOCK": "The subscription associated with this terminal is in stock, so it is not blockable",
                "POS_TERMINAL_SUBSCRIPTION_TERMINATED": "The subscription associated with this terminal is terminated, so it is not blockable",
                "POS_TERMINAL_SUBSCRIPTION_TERMINATION_IN_PROGRESS": "The subscription associated with this terminal is in termination process, so it is not blockable",
                "BLACKLIST_ERROR": "An error occurred while blocking this terminal",
                "UNKNOWN_ERROR": "An unknown error occurred while blocking this terminal",
                "UNEXPECTED_ERROR": "An unknown error occurred",
                "BAD_FILE_FORMAT": "The file format is invalid."
            },
            "message": "Please upload the example file."
        },
        "multiple_rewarehouse": {
            "title": "Multiple POS terminal rewarehouse",
            "success": "Multiple restocking successful!",
            "error_pos_terminal": "An error occurred for following pos terminal :",
            "error_pos_terminals": "An error occurred for following pos terminals :",
            "steps": {
                "select_terminals": "Step {{step}} on {{maxStep}}: Select Pos terminals",
                "confirmation": "Step {{step}} on {{maxStep}}: Confirmation"
            },
            "confirmation": {
                "text_1": "Terminal will be restocked, it will not be linked to the actual merchant.",
                "text_2": "It will be automatically assigned to a new merchant after the next remote collection, authorization or remote configuration and will show up again in subscriptions list.",
                "question": "Would you like to continue?"
            }
        }
    },
    "network_interface_type": {
        "ETHERNET": "IP/Ethernet",
        "GPRS": "GPRS/3G",
        "WIFI": "Wifi",
        "PPP": "PPP",
        "PAYLUDD": "App call",
        "OTHER": "Unknown",
        "NOT_SPECIFIED": "Not specified"
    },
    "operation_type": {
        "authorization": "Authorization",
        "remote_collection": "Remote collection",
        "remote_configuration": "Remote configuration",
        "blacklisted_pos_terminal": "Blocked",
        "pending_payment": "Payment notif.",
        "get_package": "Init. request",
        "initialization_notification": "Init. notification",
        "terminal_state": "Terminal state"
    },
    "sim": {
        "operator": "One of following operators:"
    },
    "status": {
        "TEMPORARILY_ALLOWED": "Temporary",
        "ALLOWED": "Authorized",
        "BLOCKED": "Blocked"
    },
    "toast": {
        "refresh": {
            "loading": "Refreshing in progress...",
            "success": "Refresh successfully completed",
            "error": "An error has occurred during the refresh"
        }
    },
    "tooltip": {
        "subscriptions": {
            "last_connection_type": "Type of the last connection of the terminal"
        },
        "transactions": {
            "file_number": "Archiving reference"
        }
    },
    "transaction_type": {
        "DEBIT": "Debit",
        "DEBIT_REVERSAL": "Debit reversal",
        "CREDIT": "Credit",
        "TNA": "Failure"
    },
    "card_product": {
        "1C": "Card 1st generation (4C)",
        "3C": "Card 2nd generation (3C)",
        "3C4C": "Hybrid card (3C / 4C)"
    },
    "payludd": {
        "terminal_state": {
            "refresh": "Refresh"
        },
        "state": {
            "application_version": "Payment application",
            "payludd_version": "Payludd",
            "android_version": "Android",
            "firmware": "Firmware",
            "initialization_status": "Initialization status",
            "package_code": "Customization code",
            "package_label": "Customization name",
            "initialization_date": "Initialization date",
            "last_update": "Last update",
            "mode": "Mode",
            "payment_tickets": "Payment receipts",
            "additional_services": "Additional services",
            "burger_menu_lock": "Menu lock",
            "logo": "Logo",
            "color": "Color"
        },
        "mpf": {
            "mode": {
                "CASHIER": "Cashier",
                "MANUEL": "Manual",
                "DONS": "Donations",
                "AUTOMATE": "Automated",
                "EXTERNE_APP_TO_APP": "External (App to App)",
                "EXTERNE_CONCERT_V3": "External (Concert V3)",
                "EXTERNE_CONCERT_V2": "External (Concert V2)",
                "EXTERNE_CONCERT_V2_USB": "External (Concert V2 USB)"
            },
            "receipt": {
                "nativeMerchantReceipt": "Merchant receipt printing",
                "nativeCustomerReceipt": "Customer receipt printing",
                "dematerializedReceiptQrCode": "Customer receipt QR code"
            },
            "service": {
                "tip": "Tip",
                "enabled": "Tip enabled on the terminal",
                "disabled": "Tip disabled on the terminal",
                "waiterNumber": "Employee code",
                "tableNumber": "Order reference"
            }
        },
        "initialization_status": {
            "INIT_OK": "Init OK",
            "INIT_KO": "Init KO",
            "NOT_INITIALIZED": "Not initialized",
            "UNKNOWN": "—"
        },
        "monetic_contract": {
            "uncaptured_transactions": "Uncollected transaction(s)",
            "tlp_ready": "Ready (TLP OK)",
            "yes": "Yes",
            "no": "No",
            "gateway": "Gateway"
        }
    },
    "event_logs": {
        "financial_information": {
            "acceptance_system_information": {
                "test_contract": "Test contract"
            }
        }
    }
}